var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInsertToBottom = function SvgInsertToBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.125 6.125H20.5M8.125 9.781H20.5m-5.625 3.656H20.5m-5.625 3.657H20.5m-11.812.281 3.375-2.11-3.375-2.109M6.379 13.1H4.44m0 0H2.5m1.94 0v1.94m0-1.94v-1.94"
  })));
};
export default SvgInsertToBottom;